import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { IdeaAuthorName } from "./types/idea-author-name.type";

@Component({
  selector: "app-aprove-idea-authors",
  templateUrl: "./aprove-idea-authors.component.html",
  styleUrls: ["./aprove-idea-authors.component.scss"],
})
export class AproveIdeaAuthorsComponent implements OnInit, OnChanges {
  @Input()
  authors: IdeaAuthorName[];

  authorsPopulated: IdeaAuthorName[] = [
    {id: '', name: '', re: '', email: '', newName: '', newRe: '', newEmail: ''},
    {id: '', name: '', re: '', email: '', newName: '', newRe: '', newEmail: ''},
    {id: '', name: '', re: '', email: '', newName: '', newRe: '', newEmail: ''}
  ];


  editedAuthors: IdeaAuthorName[];
  isModifiedAuthors = false;

  newAuthors: IdeaAuthorName[];

  updatedAuthors: IdeaAuthorName[] = [];

  @Output()
  newAuthorsChange = new EventEmitter<{
    authors: IdeaAuthorName[];
    isModifiedAuthors: boolean;
  }>();

  @Output()
  authorChangeReason = new EventEmitter<string>();

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['authors']) {
      this.populateAuthors();
    }
  }

  populateAuthors() {
    setTimeout(() => {
      this.authorsPopulated.forEach((item, index) => {
        if (this.authors[index]) {
          item.id = this.authors[index]?.id || '';
          item.name = this.authors[index]?.name || '';
          item.name = this.authors[index]?.name || '';
          item.re = this.authors[index]?.re || '';
          item.email = this.authors[index]?.email || '';
        }
      });
    }, 2000)
  }

  onAuthorChange() {
    const isModified = this.authors.some((item) => {
      return !!item.newName.trim() || !!item.newRe.trim() || !!item.newEmail.trim()
    });

    this.newAuthorsChange.emit({
      authors: this.authorsPopulated,
      isModifiedAuthors: isModified,
    });
  }

  onAuthorChangeReason(value: string) {
    this.authorChangeReason.emit(value);
  }
}
